import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const DoctorProfile = React.lazy(() => import('../../views/DoctorProfile'));

const params = [];
const DoctorProfileRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout>
        <DoctorProfile />
      </Layout>
    </RouteParameter>
  );
};

DoctorProfileRoute.propTypes = {};

DoctorProfileRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DoctorProfileRoute);
